import { defaultApi } from '@/plugins/api/defaultApi'
import store from '@/store'

const st = {
  name: 'choice',
  namespaced: true,
  state: {
    refreshTime: Date.now(),
    items: {},
  },
  getters: {
    codes: (state) => (key) => {
      store.dispatch(`${st.name}/init`, key)
      return state.items[key]
    },
  },
  mutations: {
    setKey(state, { key, items }) {
      state.items[key].items = items
      state.refreshTime = Date.now()
    },
  },
  actions: {
    async init({ state, commit }, key) {
      if (
        state.items[key] ||
        (state.items[key] && (state.items[key].isLoading || state.items[key].isLoaded))
      ) {
        return state.items[key]
      }
      state.items[key] = {
        isLoading: true,
      }
      try {
        const { data } = await defaultApi.getChoicesByKey(key)
        commit('setKey', {
          key,
          items: data,
        })
        state.items[key].isLoaded = true
        return state.items[key]
      } finally {
        state.items[key].isLoading = false
      }
    },
    async getName({ state, dispatch }, { key, code }) {
      await dispatch('init', key)
      if (!state[key]) {
        return null
      }
      const r = state.find((r) => r.code === code)
      return r ? r.label : null
    },
  },
}

export default st
